import { Hud, PerspectiveCamera } from '@react-three/drei'
import { useSceneStore } from '../../a.scenes/GameScene/store'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'
import BaseWindow from './components/BaseWindow/BaseWindow'
import { NavContextType } from './ScreensNav'

const TeamSelection = ({ ctx }: { ctx: NavContextType }) => {
  const { nav } = ctx
  const setPlayerTeam = useScenesStore(s => s.setPlayerTeam)

  const show = true
  return (
    <>
      <BaseWindow show={show}>
        <div className={`body-container team-selection-container`}>
          <div className="header-container">
            <span>Choose Your Side</span>
          </div>
          <div className="body-content">
            <div className="body-row witch-team">
              {/* <BattleTimer /> */}
              <span>Witch Team</span>
              <a
                className="theme-button button-orange-big orange-to-green"
                onClick={() => {
                  setPlayerTeam(CHARACTER_TYPES.WITCH)
                  nav('/next')
                }}
              >
                JOIN
              </a>
            </div>

            <div
              className="body-row"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL}/assets/images/psyco-splash.png")`,
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                height: '50%',
              }}
            ></div>
            <div className="body-row jack-team">
              <span>Jack Team</span>
              <a
                className="theme-button button-orange-big"
                onClick={() => {
                  setPlayerTeam(CHARACTER_TYPES.JACK)
                  nav('/next')
                }}
              >
                JOIN
              </a>
            </div>
          </div>
        </div>
      </BaseWindow>
    </>
  )
}

export default TeamSelection
